import {
  ERPSeedless,
  ERPRJL
} from "src/utils/constants";
import { IRoute } from "src/pages/Router/routes";

import PaymentMethodPage from "./PaymentMethod/PaymentMethodPage";

export const PaymentMethodRoutes: IRoute[] = [
  {
    exact: true,
    path: "/payment-methods/:paymentMethodId",
    pageComponent: PaymentMethodPage,
    title: "Manage your billing",
    allowedContexts: [],
    menuType: "MAIN",
    roles: [ "customer" ],
    hidden: true,
    privateRoute: true
  }
];

export default PaymentMethodRoutes;
